jQuery(document).ready(function ($) {
    $(window).on("load", function (e) {
        $.ajax({
            type: 'POST',
            url: script_object.ajax_url,
            data: {
                action: 'real_time_notifications'
            },
            success: function (response) {
                if (response) {
                    if ($('.new-notifications ').hasClass('false')) {
                        $('.new-notifications ').removeClass('false')
                        $('.new-notifications ').addClass('true')
                    }
                }
            },
        });
    })

    $(window).on("load", function (e) {
        $.ajax({
            type: 'POST',
            url: script_object.ajax_url,
            data: {
                action: 'notifications_type'
            },
            success: function (response) {
                if (response) {
                    $('.notifications-wrapper').append(response)

                    setTimeout( () => {
                        let notifications_type_selected = $('.notificationstype').attr('notificationstype');
                        const selected_types = notifications_type_selected.split(' ');
                        for (let index = 0; index < $(".type_of_notifications").length; index++) {
                            const element = $(".type_of_notifications")[index].getAttribute('value');
                            if(jQuery.inArray(element, selected_types) !== -1){
                                $(".type_of_notifications")[index].setAttribute('checked', 'checked')
                            }
                        }
                    }, 200);
                }
            },
        });
    })
    
    $(document).on("click", function (e) {
        let targeti = e.target;

        if (!targeti.closest('.notifications-wrapper')) {
            $('.notifications').addClass('d-none')
            $('.not-arrow').addClass('d-none')
        }
    });

    $(".notifications-button").on("click", function (e) {

        if ($('.new-notifications').hasClass('true')) {
            $('.new-notifications').removeClass('true')
            $('.new-notifications').addClass('false')
        }
        
        $.ajax({
            type: 'POST',
            url: script_object.ajax_url,
            data: {
                action: 'get_notifications'
            },
            success: function (response) {
                if ($('.notifications').hasClass('d-none')) {
                    $('.notifications').removeClass('d-none')
                } else {
                    $('.notifications').addClass('d-none')
                }

                if ($('.not-arrow').hasClass('d-none')) {
                    $('.not-arrow').removeClass('d-none')
                } else {
                    $('.not-arrow').addClass('d-none')
                }
                $('.notifications ').html(response);
            },
        });
    });


    $("#toggleMenu").on("click", function (e) {
        if ($('.mobile-menu').hasClass('show')) {
            $('.notifications-wrapper').addClass('d-xl-none')
            $('.notifications-wrapper').addClass('d-block')
        } else {
            $('.notifications-wrapper').removeClass('d-xl-none')
            $('.notifications-wrapper').removeClass('d-block')
            $('.notifications-wrapper').addClass('d-none')
        }
    });

    $(".type_of_notifications").on("click", function (e) {

        if ($(this).attr( 'checked') == 'checked') {
            $(this).removeAttr('checked') 
          }else{
            $(this).attr('checked', true)
          }
          

        let notification_type = $(this).attr('value');

        $.ajax({
            method: 'POST',
            url: script_object.ajax_url,
            type: 'JSON',
            data: {
                action: 'content',
                notification_type: notification_type,
            },
            success: function (response) {
            },
        });
    });

});